import clsx from "clsx";
import { CSSProperties } from "react";

import { Card } from "../../../Card";

import styles from "./TileSkeleton.module.scss";

type TileSkeletonProps = {
  className?: string;
  style?: CSSProperties;
};

export const TileSkeleton = ({ className, style }: TileSkeletonProps) => (
  <Card className={clsx(styles.tile, className)} style={style}>
    <div className={styles.icon} />
    <div className={styles.title} />
  </Card>
);
